(() => {
  const initialize = (root) => {
    if (root.dataset.groupGiftsReady) return;
    root.dataset.groupGiftsReady = 'true';
    root.addEventListener('click', (event) => {
      const occasionLink = event.target.closest('[data-occasion]');
      if (occasionLink) {
        const select = root.querySelector('[data-occasion-select]');
        if (select) {
          select.value = occasionLink.dataset.occasion;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      const woodButton = event.target.closest('[data-wood]');
      if (woodButton) {
        root.querySelectorAll('[data-wood]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === woodButton));
        });
        root.querySelectorAll('[data-wood-image]').forEach((image) => {
          image.hidden = image.dataset.woodImage !== woodButton.dataset.wood;
        });
      }
    });
    root.querySelectorAll('.egg-motion').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) details.querySelector('video')?.pause();
      });
    });
    const message = root.querySelector('[data-form-message]');
    if (message) {
      message.focus({ preventScroll: true });
      message.scrollIntoView({ block: 'center' });
    }
  };
  const scan = (scope = document) => {
    if (scope.matches?.('[data-group-gifts]')) initialize(scope);
    scope.querySelectorAll('[data-group-gifts]').forEach(initialize);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
